import moment from "moment";

export const showDeliveryTime = (deliveryTime) => !!deliveryTime;

export const formatDeliveryTime = (deliveryTime) => !!deliveryTime ? moment(deliveryTime, "HH:mm:ss").format("LT") : "";

export const formatHourTimeOrDefault = (deliveryTime) => !!deliveryTime ? moment(deliveryTime, "HH:mm").format("LT") : "--:--";
